/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceLaptopOff = createReactComponent("outline", "device-laptop-off", "IconDeviceLaptopOff", [["path", { "d": "M3 19h16", "key": "svg-0" }], ["path", { "d": "M10 6h8a1 1 0 0 1 1 1v8m-3 1h-10a1 1 0 0 1 -1 -1v-8a1 1 0 0 1 1 -1", "key": "svg-1" }], ["path", { "d": "M3 3l18 18", "key": "svg-2" }]]);

export { IconDeviceLaptopOff as default };
//# sourceMappingURL=IconDeviceLaptopOff.mjs.map
